import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const apiUrl = environment.apiUrl + 'user/checkout';

@Injectable({
  providedIn: 'root',
})
export class UserCheckoutService {
  constructor(private http: HttpClient) {}

  cancelOrderCheckout(id: any) {
    return this.http.post(apiUrl + `/${id}/cancel`, '');
  }
}
